<template>
  <div>
    <div class="u-input-multiStepForm">
      <p class="ff-logo ta-c" v-show="!!currentItem.question"><span class="fz300">{{ currentIndex + 1 }}</span><span class="fz125 c-black50">／{{ questionLength }}</span></p>
      <div>
        <div class="plr10" :data-index="index" v-for="({ key, question, input_type, optional = false, options = {} }, index) in items">
          <div v-show="currentIndex === index">
            <div class="d-f ai-c jc-c">
              <span class="d-ib lh100 c-white fw-b p5 mr5 bdrs4" style="background-color: #a0a0a0;" v-show="optional">任意</span>
              <span class="fz110 fw-b lh140 ta-c" :class="`c-${colors[propGentype]}`" v-show="!!question">{{ question }}</span>
            </div>
            <div class="mt15">
              <component :is="getComponent(input_type)" :prop-name="`${key}`" :prop-value="getPropValue(key, input_type)" :prop-options="options" :prop-optional="optional" :ref="'step-' + index" @valid="valid" @invalid="invalid" />
            </div>
          </div>
        </div>
      </div>
      <div class="mt20 d-f ai-c jc-c gap10 plr10" :class="currentIndex === items.length - 1 && 'fxd-cr'">
        <div class="f1 w-max">
          <button type="button" class="fz165 bdrs10 ptb10 plr20 w-max u-reset-button hov ff-logo ta-c" @click="prev()" v-show="currentIndex > 0">戻る</button>
        </div>
        <div class="f1 w-max">
          <button
            type="button"
            :data-type="currentIndex === items.length - 1 ? 'submit' : 'button'"
            class="fz165 bdrs10 ptb10 plr20 w-max u-reset-button hov ff-logo ta-c c-white"
            :class="currentItemIsValid ? 'bgc-key' : 'bgc-black50'"
            :disabled="!currentItemIsValid"
            @click="handleButtonClick($event)"
          >
            <span v-show="currentIndex === items.length - 1">{{ submitButtonText }}</span>
            <span v-show="currentIndex !== items.length - 1">次へ</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { popupSuccess, popupError, popupInfo } from '@/packs/person/popup';
import Text from './PersonMultiStepForm/Text.vue';
import TextArea from './PersonMultiStepForm/TextArea.vue';
import Select from './PersonMultiStepForm/Select.vue';
import CharCount from './PersonMultiStepForm/CharCount.vue';
import YearMonth from './PersonMultiStepForm/YearMonth.vue';

const COMPONENTS_MAP = {
  text: Text,
  textarea: TextArea,
  select: Select,
  year_month: YearMonth,
  char_count: CharCount,
};

const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

export default {
  props: {
    propItems: Array,
    propFormParams: Object,
    propGentype: String,
  },
  data() {
    return {
      items: [],
      questionLength: 0,
      currentIndex: 0,
      currentItem: {},
      currentItemIsValid: false,
      nowSending: false,
      submitButtonText: '文章を生成する',
      colors: {
        selfpr: 'key',
        reason: 'red',
        point: 'blue',
        gakuchika: 'purple',
        seminar: 'seminar',
        'career-history': 'limegreen',
      },
    }
  },
  watch: {
  },
  created() {
    this.items = this.propItems;
    this.questionLength = this.items.filter(({ question }) => !!question).length;
    this.currentItem = this.items[this.currentIndex];
  },
  mounted() {
    this.validateCurrentStep();
  },
  methods: {
    getComponent(type) {
      return COMPONENTS_MAP[type] ?? Text;
    },
    getPropValue(key, input_type) {
      if (input_type === 'year_month') {
        return {
          year: this.propFormParams[key + '_year'],
          month: this.propFormParams[key + '_month'],
          ongoing: this.propFormParams[key + '_ongoing'],
        };
      }
      return this.propFormParams[key];
    },
    prev() {
      this.currentIndex = Math.max(this.currentIndex - 1, 0);
      this.currentItem = this.items[this.currentIndex];
      this.validateCurrentStep();
    },
    next() {
      this.currentIndex = Math.min(this.currentIndex + 1, this.items.length - 1);
      this.currentItem = this.items[this.currentIndex];
      this.validateCurrentStep();
    },
    handleButtonClick(e) {
      this.next();
      if (e.currentTarget.dataset.type === 'submit' && !this.nowSending) {
        this.nowSending = true;
        this.submitButtonText = '送信中';
        e.target.closest('form').submit();
      }
    },
    validateCurrentStep() {
      this.$nextTick(() => {
        const refs = this.$refs['step-' + this.currentIndex];
        const child = Array.isArray(refs) ? refs[0] : refs;
        if (child && typeof child.validate === 'function') {
          child.validate();
        } else {
          this.currentItemIsValid = false;
        }
      });
    },
    valid() {
      this.currentItemIsValid = true;
    },
    invalid() {
      this.currentItemIsValid = false;
    },
  },
}
</script>
